import api from './api'

export async function uploadSupportScreenshot(shopId: string | null, file: File) {
  const contentType = file.type || 'application/octet-stream'
  const payload: Record<string, string> = {
    entityType: 'photo',
    entityId: 'support-report',
    filename: file.name,
    contentType,
  }

  if (shopId) {
    payload.shopId = shopId
  }

  const { data: signed } = await api.post('/uploads/sign', payload)

  const uploadResult = await fetch(signed.uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
    },
    body: file,
    // The upload URL is the API's authenticated proxy — the session cookie
    // must ride along (cross-origin in production).
    credentials: 'include',
  })

  if (!uploadResult.ok) {
    throw new Error(`Screenshot upload failed (${uploadResult.status})`)
  }

  return signed.publicUrl as string
}

export async function submitSupportReport(report: {
  message: string
  screenshotUrl?: string | null
  route?: string
  shopId?: string
  metadata?: Record<string, unknown>
}) {
  const { data } = await api.post('/support/report', report)
  return data.data
}

export async function fetchSupportReports(params?: { shopId?: string; status?: 'open' | 'resolved' }) {
  const query = new URLSearchParams()
  if (params?.shopId) query.set('shopId', params.shopId)
  if (params?.status) query.set('status', params.status)

  const suffix = query.toString() ? `?${query.toString()}` : ''
  const { data } = await api.get(`/support/admin${suffix}`)
  return data.data
}

export async function fetchSupportReport(id: string) {
  const { data } = await api.get(`/support/admin/${id}`)
  return data.data
}

export async function resolveSupportReport(id: string) {
  const { data } = await api.patch(`/support/admin/${id}/resolve`)
  return data.data
}
